<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Versandoption erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.payment-methods.store'))">
                <form-fields :form="form" :tax-calc-mode-options="taxCalcModeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    description: null,
                    sort_order: null,
                    enabled: true,
                    notes: true,
                    options: [],
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>